// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CouponDocumentsSubmitDocumentsSubmitDocumentsRequest {
    static getAttributeTypeMap() {
        return CouponDocumentsSubmitDocumentsSubmitDocumentsRequest.attributeTypeMap;
    }
}
CouponDocumentsSubmitDocumentsSubmitDocumentsRequest.discriminator = undefined;
CouponDocumentsSubmitDocumentsSubmitDocumentsRequest.additionalProperties = false;
CouponDocumentsSubmitDocumentsSubmitDocumentsRequest.attributeTypeMap = [
    {
        "name": "programId",
        "baseName": "programId",
        "type": "number"
    },
    {
        "name": "body",
        "baseName": "body",
        "type": "CouponSubmitDocumentsRequestModel"
    },
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
];
//# sourceMappingURL=couponDocumentsSubmitDocumentsSubmitDocumentsRequest.js.map